import kr from '../../kr/kr';
import DivStatuses from '../../kr/utils/DivStatuses';
import HTMLClass from '../../kr/utils/HTMLClass';

export default class CheckShopStatus extends kr.Component {
    init() 
    {
        this.$ = window.jQuery;
        this.verifiedKey = this.$element.querySelector('input[name="verified_key"]').value;
        this.$loading = this.$element.querySelector('.js-sellyCSStatusLoading');
        this.$messages = new DivStatuses(this.$element);
        this.waitingTime = 30000;
        this.timeSec = 0;
        this.bind();
    }

    bind()
    {
        const formData = new FormData();
        formData.append('action', 'sellycheckstatus');
        formData.append('verify', this.verifiedKey);
        this.checkStatus(formData);
    }

    async checkStatus(data)
    {
        let result;
        try {
            result = await this.ajax(data);
            if (!result.success) {
                throw result.error;
            }
        } catch (error) {
            this.$loading.style.display = "none";
            this.$messages.message(error, 'error');
        }

        if (result.status == 2) {
            let waitTime = this.waitingTime - this.timeSec;
            if (waitTime < 0) {
                waitTime = 1;
            }
            setTimeout(() => {
                this.success(result.tpl);
            }, waitTime);
        } else {
            setTimeout(() => {
                this.timeSec = this.timeSec + 5000;
                this.checkStatus(data);
            }, 5000);
        }
    }

    success(tpl)
    {
        document.querySelector('.js-sellyCSContent').innerHTML = tpl
    }

    async ajax(data)
    {        
        return this.$.ajax({
            type: 'POST',
            url: window.selly_create_shop.ajaxurl,
            data: data,
            cache: false,
            processData: false, 
            contentType: false,
        })
    }
}

kr.registerComponent('.js-sellyCSStatus', {
    component: CheckShopStatus,
    name: 'CheckShopStatus'
});